import React, {useEffect, useState} from "react";
import {notifySuccess} from "../../utils/helpers";
import {
    BUTTON,
    MODAL_CANCEL_TEXT,
    MODAL_CLOSE_TEXT, EMAIL, SHARE_TEXT, EMAIL_TEXT
} from "../../utils/constants";
import {Modal} from "react-bootstrap";
import YuJaButton from "../standardization/YuJaButton";
import { ReactComponent as ModalClose } from "../../images/modal_close.svg";

import {YuJaTextBox} from "../standardization/YuJaTextBox";
import {USAGE_EMAIL_HAS_BEEN_SHARED_SUCCESS} from "../../utils/toast-message-constants";
import {ReportApiCalls} from "../../apis/ReportApiCalls";
import settingsClasses from "../../pages/PlatformSetting/Settings.module.css";
import {ReactComponent as STAR_RED_ICON} from "../../images/star_red.svg";
import settingClasses from "../../pages/PlatformSetting/Settings.module.css";
import FocusTrap from "../FocusTrap";


export default function ShareUsageReportModal({setModalShow, show, yearMonth}) {
    const {shareUsageReport} = ReportApiCalls();

    const [email, setEmail] = useState("");
    const [isSaving, setIsSaving] = useState(false);
    const [isValidated, setIsValidated] = useState(true);

    let year = parseInt(yearMonth.split("-")[0]);
    let month = parseInt(yearMonth.split("-")[1]);
    let formatedYearMonth = new Date(year, month - 1).toLocaleString("en-US", {
        month: "long",
        year: "numeric",
    });


    const handleClose = () =>{
        setModalShow(false);
    };

    const handleSave = () => {
        setIsSaving(true);
        shareUsageReport(yearMonth, email).then((success) => {
            if (success) {
                const dateObj = new Date(yearMonth);
                let month = dateObj.toLocaleString('default', { month: 'long'});
                let year = dateObj.toLocaleString('default', { year: 'numeric'});
                notifySuccess(USAGE_EMAIL_HAS_BEEN_SHARED_SUCCESS
                    .replace(EMAIL_TEXT, email)
                    .replace("yearMonth", `${month} ${year}`)
                );
            }

            setModalShow(false);
            setEmail("");
        }).finally(() => setIsSaving(false));
    };


    useEffect(() => {
        if (!email) {
            setIsValidated(true);
            return;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        setIsValidated(emailRegex.test(email));
    }, [email]);


    // usageMonthlyCardContainer
    useEffect(() => {
        const handleKeyDownDropdown = (event) => {
            if (event.key === 'Escape') {
                setModalShow(false);
                return;
            }

            if (event.key !== "Tab") {
                return;
            }
            const container = document.querySelector(`#share-usage-report-modal`);
            if (!container) {
                return;
            }

            const focusableElements = container.querySelectorAll('[tabindex]:not([tabindex="-1"]), input');

            if (!container.contains(event.target)) {
                event.preventDefault();
                focusableElements[0].focus();
                return;
            }

            if (event.shiftKey) {
                for (let i = 0; i < focusableElements.length; i++) {
                    if (focusableElements[i] !== event.target) {
                        continue;
                    }
                    if (i === 0) {
                        event.preventDefault();
                        focusableElements[focusableElements.length - 1].focus();
                        return;
                    } else {
                        event.preventDefault();
                        focusableElements[i - 1].focus();
                        return;
                    }
                }
            } else {
                for (let i = 0; i < focusableElements.length; i++) {
                    if (focusableElements[i] !== event.target) {
                        continue;
                    }
                    if (i === focusableElements.length - 1) {
                        event.preventDefault();
                        focusableElements[0].focus();
                        return;
                    } else {
                        event.preventDefault();
                        focusableElements[i + 1].focus();
                        return;
                    }
                }
            }

        };

        if (!!show) {
            document.addEventListener("keydown", handleKeyDownDropdown);
        }


        return () => {
            document.removeEventListener("keydown", handleKeyDownDropdown);
        };
    }, [show]);

    return (
        <FocusTrap>
            <Modal
                id="share-usage-report-modal"
                show={show}
                aria-labelledby="contained-modal-title-vcenter"
                backdrop={true}
                dialogClassName= {"save-question-bank-modal"}
            >

                <ModalClose
                    tabIndex={0}
                    role={BUTTON}
                    aria-label={MODAL_CLOSE_TEXT}
                    onClick={handleClose}
                    className="modal-close"
                    style={{width: "24px", height: "24px"}}
                />
                <Modal.Header
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <Modal.Title as="h2" className="modal-title" id="contained-modal-title-vcenter">
                        {"Share Report"}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{display: "flex", flexDirection: "column", gap: 25, minHeight: 100}}>
                    <span style={{color: "#6B6B6B", fontSize: 15, fontWeight: "400"}}>
                        {`Enter email of the user that you want to share the ${formatedYearMonth} Monthly Usage Report with.`}
                    </span>
                    <div className={settingsClasses.settingColumn}>
                        <div className={settingClasses.settingLabel}>
                            {EMAIL} <STAR_RED_ICON/>
                        </div>
                        <YuJaTextBox
                            value={email}
                            containerStyle={{height: 40, fontSize: 15}}
                            onChange={e => setEmail(e.target.value)}
                            placeholder={"Enter email"}
                            isInvalid={!isValidated}
                            errorMsg={"Enter a valid email"}
                            limitedSpace={false}
                        />
                    </div>

                </Modal.Body>
                <Modal.Footer>
                    <div style={{display: "flex", width: "100%", alignItems: "center", justifyContent: "flex-end", gap: 10}}>
                        <span style={{display: "flex", width: "100%", alignItems: "center", justifyContent: "flex-end", gap: 10}}>
                            <YuJaButton
                                onClick={handleClose}
                                type={"secondary"}
                                style={{width: 80, height: 36, display: "flex", alignItems: "center", justifyContent: "center"}}
                            >
                               {MODAL_CANCEL_TEXT}
                            </YuJaButton>

                            <YuJaButton
                                onClick={handleSave}
                                disabled={!email || !isValidated || !!isSaving}
                                style={{width: 80, height: 36, display: "flex", alignItems: "center", justifyContent: "center", whiteSpace: "nowrap"}}
                            >
                               {SHARE_TEXT}
                            </YuJaButton>
                        </span>
                    </div>
                </Modal.Footer>

            </Modal>
        </FocusTrap>
    );
}